import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import PinInput from 'react-pin-input';

/**
 * @type {React.FC<{
 * inputStyle?: object;
 * onComplete?: (pin: string) => void;
 * }>}
 */
var PinField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _onComplete = _ref.onComplete,
    _ref$inputStyle = _ref.inputStyle,
    inputStyle = _ref$inputStyle === void 0 ? {} : _ref$inputStyle;
  var settings = {
    inputStyle: _objectSpread({
      borderRadius: '4px',
      fontSize: '19px',
      color: '#677882',
      fontWeight: 'bold',
      height: '45px',
      width: '40px',
      marginLeft: '5px',
      marginRight: '5px',
      paddingTop: '2px',
      paddingLeft: '2px',
      border: '1px solid #BCCAD2'
    }, inputStyle),
    inputFocusStyle: {
      border: '1px solid #4C94D7',
      boxShadow: '0px 1px 6px rgba(11, 153, 230, 0.4)'
    }
  };
  return __jsx(PinInput, _extends({
    length: 4,
    focus: true,
    type: "numeric",
    pattern: "[0-9]*",
    inputMode: "number",
    autocomplete: "one-time-code",
    id: "alpineIqPinInput",
    ref: ref,
    onComplete: function onComplete(value, _) {
      _onComplete(value);
    }
  }, settings));
});
export default PinField;